export interface IDocumentImportInformation{
    documentId: number;
    documentType: string;
    companyId?: number | null;
    companyName?: string | null;
    supplierId?: number | null;
    supplierName?: string | null;
    invoiceNumber?: string | null;
    contractNumber?: string | null;
    orderIdentifier?: string | null;
    orderIdentifier2?: string | null;
    invoiceReference?: string | null;
    paymentReference?: string | null;
    documentSource ?: string | null;
    documentFormat ?: string | null;
    documentProvider ?: string | null;
    documentOriginalFormat ?: string | null;
    eInvoiceTrackingId ?: string | null;
    paymentTermId?: number | null;
    paymentTerm?: string | null;
    reconciled?: boolean | null;
    deliveryNote?: string | null;
    invoiceDate?: string | null;
    dueDate?: string | null;
    preferredPaymentDate?: string | null;
    preliminaryPostingDate?: string | null;
    createDate?: string | null;
    importDate?: string | null;
    platformAssignedDate?: string | null;
    isStraightToArchive?: boolean | null;
    prepaymentCategoryId?: number | null;
    prepaymentCategory?: string | null;
    customFieldTextCustomField1?: string | null;
    textCustomField1Name?: string | null;
    customFieldListCustomField1Value?: string | null;
    listCustomField1Name?: string | null;
    customFieldNumericCustomField1?: number | null;
    numericCustomField1Name?: string | null;
    customFieldBooleanCustomField1?: boolean | null;
    booleanCustomField1Name?: string | null;
    customFieldDateTimeCustomField1?: string | null;
    dateTimeCustomField1Name?: string | null;
    customFieldTextCustomField2?: string | null;
    textCustomField2Name?: string | null;
    customFieldListCustomField2Value?: string | null;
    listCustomField2Name?: string | null;
    customFieldNumericCustomField2?: number | null;
    numericCustomField2Name?: string | null;
    customFieldBooleanCustomField2?: boolean | null;
    booleanCustomField2Name?: string | null;
    customFieldDateTimeCustomField2?: string | null;
    dateTimeCustomField2Name?: string | null;
    customFieldTextCustomField3?: string | null;
    textCustomField3Name?: string | null;
    customFieldListCustomField3Value?: string | null;
    listCustomField3Name?: string | null;
    customFieldNumericCustomField3?: number | null;
    numericCustomField3Name?: string | null;
    customFieldBooleanCustomField3?: boolean | null;
    booleanCustomField3Name?: string | null;
    customFieldDateTimeCustomField3?: string | null;
    dateTimeCustomField3Name?: string | null;
    customFieldTextCustomField4?: string | null;
    textCustomField4Name?: string | null;
    customFieldListCustomField4Value?: string | null;
    listCustomField4Name?: string | null;
    customFieldNumericCustomField4?: number | null;
    numericCustomField4Name?: string | null;
    customFieldBooleanCustomField4?: boolean | null;
    booleanCustomField4Name?: string | null;
    customFieldDateTimeCustomField4?: string | null;
    dateTimeCustomField4Name?: string | null;
    customFieldTextCustomField5?: string | null;
    textCustomField5Name?: string | null;
    customFieldListCustomField5Value?: string | null;
    listCustomField5Name?: string | null;
    customFieldNumericCustomField5?: number | null;
    numericCustomField5Name?: string | null;
    customFieldBooleanCustomField5?: boolean | null;
    booleanCustomField5Name?: string | null;
    customFieldDateTimeCustomField5?: string | null;
    dateTimeCustomField5Name?: string | null;
}